<template>
	<div class="app">
		<div class="outer">
			<div class="inner">
				<div class="header">
					<span class="uppercase cost-label text-center">Ticket Cost</span>
					<span class="cost bold">{{ cost | currency }}</span>
					<ul>
						<li><a href="#" @click.prevent="clear"><img v-icon.literal="clear.svg" alt="Clear" /></a></li>
					</ul>
				</div>
				<div class="row collapse bordered bottom controls">
					<div class="small-6 medium-4 columns">
						<select class="noborder" required v-model="betValue">
							<option value="" disabled selected hidden>Bet Amount</option>
							<option value="{{ value }}" v-for="value in betValues">{{ value | currency }}</option>
						</select>
					</div>
					<div class="small-6 medium-4 columns">
						<select class="noborder" required v-model="selectedBetID">
							<option value="" disabled selected hidden>Bet Type</option>
							<option :value="key" v-for="(key, bet) in bets">{{ bet.title() }}</option>
						</select>
					</div>
					<div class="small-12 medium-4 columns checkbox" :class="{ 'show-for-medium': !enableBox }">
						<div v-show="enableBox">
							<span class="checkbox-outer" :class="{ 'checked': box }">
								<input id="box" type="checkbox" v-model="box" />
							</span>
							<label for="box" class="bold uppercase" :class="{ 'inactive': !box }">Box</label>
						</div>
					</div>
				</div>
				<div class="row collapse calculator-body" :class="{ 'align-center': selectors.length <= 0, 'bordered': selectors.length > 0 }">
					<template v-if="selectors.length > 0">
						<horse-selector :title="selector.label" :key="selector.key" @selection-changed="selectionChanged" v-ref:selectors v-for="selector in selectors" :cloths="numberOfCloths"></horse-selector>
					</template>
					<template v-else>
						<div class="small-12 medium-10 large-8 columns text-center no-selectors">
							<span>Get started by selecting a bet amount and bet type using the dropdowns above.</span>
						</div>
					</template>
				</div>
			</div>
		</div>
		<div class="row toggler show-for-medium" v-show="selectedBetID">
			<div class="small-12 columns text-center">
				<a href="#" class="toggle-link separator-border" @click.prevent="increaseClothCount" :class="{ 'visible': numberOfCloths !== 13 }">
					<span class="text">
						<span class="read-text">View More</span>
						<span class="hide-text">View Less</span>
					</span>
					<img v-icon.literal="down-arrow.svg"/></a>
			</div>
		</div>
	</div>
</template>

<script>
	import bets from '../bets/bets';
	import HorseSelector from './HorseSelector.vue'
	import _ from 'underscore'
	export default {
		components: { HorseSelector },
		data() {
			return {
				bets: bets,
				selectedBetID: null,
				cost: 0,
				selectors: [],
				betValues: [.1, .5, 1, 2, 3, 4, 5, 10, 20, 50],
				betValue: null,
				box: false,
				selections: {},
				numberOfCloths: 13,
				enableBox: true
			};
		},
		watch: {
			'selectedBetID': function () {
				if (typeof(bets[this.selectedBetID]) !== 'undefined') {
					this.selectors = bets[this.selectedBetID].selectors();
					this.enableBox = bets[this.selectedBetID].enableBox();
				} else {
					this.selectors = [];
				}
				this.cost = 0;
			},
			'betValue': 'calculate',
			'box': function () {
				if (this.box) {
					this.matchSelectors(_.first(_.keys(this.selections)), _.first(_.values(this.selections)), true);
				}
				this.calculate();
			},
			'selectors': function () {
				this.selections = {};
				var self = this;
				_.each(this.selectors, function (selector) {
					self.selections[selector.key] = [];
				});
			},
			'enableBox': function () {
				if (!this.enableBox) {
					this.box = false;
				}
			}
		},
		methods: {
			calculate () {
				var self = this;
				if (typeof(bets[self.selectedBetID]) === 'undefined') return;
				var bet = bets[self.selectedBetID];
				var permutations = bet.permutations(_.values(self.selections), self.box);
				self.cost = permutations * self.betValue;
				if (!self.cost) self.cost = 0;
			},
			clear () {
				this.box = false;
				this.selectedBetID = '';
				this.cost = 0;
				this.betValue = '';
				this.enableBox = true;
			},
			increaseClothCount () {
				if (this.numberOfCloths === 13) {
					this.numberOfCloths = 24;
				} else {
					this.numberOfCloths = 13;
				}
			},
			matchSelectors (selectorKey, selections, fireSelf) {

				// Update all the selectors without firing the
				// watcher events.
				for (var refKey in this.$refs.selectors) {
					if (!this.$refs.selectors.hasOwnProperty(refKey)) continue;
					if (this.$refs.selectors[refKey].key === selectorKey && !fireSelf) continue;
					this.$refs.selectors[refKey].updateSelections(_.clone(selections), false);
				}

				// Update all the selections internally.
				for (var key in this.selections) {
					if (!this.selections.hasOwnProperty(key)) continue;
					this.selections[key] = selections;
				}

			},
			selectionChanged (selectorKey, selections) {
				if (this.box) {
					this.matchSelectors(selectorKey, selections, false);
				} else {
					this.selections[selectorKey] = selections;
				}
				this.calculate();
			}
		}
	}
</script>



/** WEBPACK FOOTER **
 ** App.vue?3342c641
 **/